"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TwitterIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  d: "M24 4.23798C23.1094 4.62621 22.1719 4.88882 21.164 5.00301C22.1953 4.40926 22.9687 3.46154 23.3321 2.34255C22.3945 2.89063 21.3281 3.29027 20.2266 3.50721C19.3008 2.59375 18.0234 2 16.6055 2C13.8868 2 11.6953 4.13521 11.6953 6.78426C11.6953 7.16106 11.7187 7.54929 11.8008 7.89183C7.72266 7.67489 4.11328 5.8708 1.66406 2.97055C1.2539 3.67849 0.996094 4.40926 0.996094 5.29989C0.996094 6.94412 1.86328 8.40566 3.19922 9.27344C2.39063 9.25061 1.64063 9.03367 0.972656 8.67969V8.73679C0.972656 11.0661 2.67187 13.0072 4.92187 13.4411C4.5 13.5553 4.05469 13.6124 3.60937 13.6124C3.30469 13.6124 3 13.5782 2.69531 13.521C3.30469 15.4164 5.14453 16.8324 7.27734 16.8552C5.61328 18.1569 3.46874 19.1275 1.17187 19.1275C0.773437 19.1275 0.386719 19.1046 0 19.0475C2.16797 20.4063 4.78126 21 7.5586 21C16.6055 21 21.5508 13.6923 21.5508 7.35518V6.72717C22.5 6.05349 23.3321 5.21996 24 4.23798Z",
  fill: "currentColor"
}));

var _default = TwitterIcon;
exports.default = _default;